import api from './api';

const getAll = (pagination, filter, sortColumn) => api.get('/category', {
    pageNum: pagination.currentPage - 1, 
    pageLength: pagination.itemsPerPage, 
    active: filter.active,
    search: filter.search,
    sortBy: sortColumn.sortByColumn,
    orderBy: sortColumn.orderBy
})
    .then(response => {
    return response.data;
});

const selectAll = () => api.get('/category/lazy').then(response => {
    return response.data
});

const getById = (id) => api.get(`/category/${id}`).then(response => {
    return response.data
});

const create = (data) => api.post('/category', data).then(response => {
    return response.data
});

const update = (id, data) => api.put(`/category/${id}`, data).then(response => {
    return response.data
});

const remove = (id) => api.delete(`/category/${id}`).then(response => {
    return response.data
});

const CategoryService = {
    getAll,
    selectAll,
    getById,
    create,
    update,
    remove
};

export default CategoryService;